export default __webpack_public_path__ + "static/media/key.18fadc75.png";